import { render, staticRenderFns } from "./dr-tab.vue?vue&type=template&id=300ae2a4&"
import script from "./dr-tab.vue?vue&type=script&lang=js&"
export * from "./dr-tab.vue?vue&type=script&lang=js&"
import style0 from "./dr-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports